const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "25.6px",
    viewBox: "0 0 28 25.6",
    style: {
      enableBackground: "new 0 0 28 25.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M27.3,17.9L18.5,2.6c-1.4-2.5-4.6-3.3-7-1.9C10.6,1.1,10,1.8,9.5,2.6L0.7,17.9c-0.7,1.2-0.9,2.6-0.5,3.9 s1.2,2.5,2.4,3.1c0.8,0.5,1.7,0.7,2.6,0.7h17.6c0,0,0,0,0,0c1.9,0,3.6-1,4.5-2.6C28.2,21.5,28.2,19.5,27.3,17.9z M24.9,21.6 L24.9,21.6c-0.4,0.7-1.2,1.2-2.1,1.2c0,0,0,0,0,0H5.2c0,0,0,0,0,0c-0.8,0-1.6-0.4-2-1.2c-0.4-0.7-0.4-1.6,0-2.4L12,4 c0.3-0.5,0.8-0.9,1.4-1.1c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0,0.8,0.1,1.2,0.3C15.5,3.3,15.8,3.6,16,4l8.8,15.3 C25.3,20,25.3,20.9,24.9,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M14,17.6L14,17.6c-0.4,0-0.7,0.2-1,0.4c-0.3,0.3-0.4,0.6-0.4,1c0,0.7,0.6,1.3,1.3,1.3c0.4,0,0.7-0.2,1-0.4 c0.3-0.3,0.4-0.6,0.4-1C15.3,18.2,14.7,17.6,14,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M13.7,8.4L13.7,8.4c-0.7,0.2-1.1,0.8-1.1,1.5c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6c0,0.8,0.1,1.6,0.1,2.4 c0,0.8,0.1,1.5,0.1,2.3c0,0.5,0.5,1,1,1c0,0,0,0,0,0c0.6,0,1-0.4,1-1c0-0.3,0-0.6,0-0.9c0-0.6,0.1-1.2,0.1-1.7 c0-0.4,0.1-0.9,0.1-1.3c0-0.3,0-0.7,0.1-1c0-0.3,0-0.7,0.1-1c0-0.2,0-0.5-0.1-0.7C15,8.6,14.3,8.3,13.7,8.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.91cf5cb68cb5536a542707cdfedb42fa.svg";
export { ForwardRef as ReactComponent };